import { useQuery } from "react-query";
import { api, ApiError } from "utils/api";
import type { RewardToken } from "../types";

const rewardKeys = {
  base: "rewards",
  user: (id: string) => [rewardKeys.base, id],
};

/**
 * Fetch a user's RewardTokens
 */
const getProfileRewards = (userId: string): Promise<RewardToken[]> =>
  api(`/users/${userId}/tokens`);

const useRewards = (userId: string) =>
  useQuery<RewardToken[], ApiError>(
    rewardKeys.user(userId),
    () => getProfileRewards(userId),
    {
      enabled: !!userId,
    }
  );

export { rewardKeys, useRewards };
